import { useMutation, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useAuth } from './useAuth'
import { WithdrawService } from '../services/WithdrawService'
import { useEffect } from 'react'

export const useCommissionAmount = () => {
  const { user } = useAuth()
  const { isError, isFetching, data, isLoading, refetch } = useQuery({
    queryKey: ['commission', 'amount', user?._id],
    queryFn: () => {
      if (user?._id) return WithdrawService.getAvailableAmount(user?._id)
    },
  })

  const { toast } = useToast()

  const { mutateAsync: createWithdraw } = useMutation({
    mutationFn: (amount: number) => WithdrawService.createWithdraw(amount),
    onSuccess() {
      refetch()
    },
  })

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar as transações, tente novamente mais tarde.',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    createWithdraw,
  }
}
